import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Paper,
} from '@mui/material';

export default function ContactPage() {
  return (
    <Box sx={{ py: 8, minHeight: '100vh', background: 'rgb(237, 236, 235)' }} >
      <Container maxWidth="sm">
        <Paper sx={{ p: 4, borderRadius: 3 }}>
          <Typography variant="h4" fontWeight={700} gutterBottom>
            Contact Us
          </Typography>
          <Typography variant="body1" mb={3}>
            Have a question or feedback? We'd love to hear from you.
          </Typography>

          <Box
            component="form"
            action="https://formsubmit.co/ashton@chocchipstudios.com"
            method="POST"
            noValidate
          >
            {/* Hidden fields to customize behavior */}
            <input type="hidden" name="_captcha" value="false" />
            <input type="hidden" name="_template" value="box" />
            <input type="hidden" name="_next" value="https://chocchipstudios.com/thank-you" />

            <TextField
              fullWidth
              name="name"
              label="Name"
              margin="normal"
              required
            />
            <TextField
              fullWidth
              name="email"
              label="Email"
              type="email"
              margin="normal"
              required
            />
            <TextField
              fullWidth
              name="message"
              label="Message"
              multiline
              rows={4}
              margin="normal"
              required
            />
            <Button type="submit" variant="contained" size="large" sx={{ mt: 2 }}>
              Send Message
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
